

import { axiosInstance } from "../api/axiosConfig";

export type responseAction = {
  status: "success" | "error";
  stripeUrl?: string;
};

export async function openCustomerPortal(base_url: string) {
  let redirectUrl: string = "";
  try {
    const response = await axiosInstance.get(
      `/subscription/stripe/cs-link?base_url=${base_url}`,
    );

    if (response.data.data.url) redirectUrl = response.data.data.url;
    else {
      throw new Error(response.data.message);
    }
  } catch (_) {
    throw new Error("Failed to generate customer portal" + JSON.stringify(_));
  }

  window.location.assign(redirectUrl);
}

export async function generateCheckout(
  base_url: string,
  priceId: string,
  coupon?: string,
  trial: boolean = false,
  referral?: string
) {
  let redirectUrl: string = "";

  const params: any = {
    base_url: base_url,
    price_id: priceId,
    requested_trail: trial,
    affilate_id: referral
  }

  if (coupon) {
    params.coupon = coupon;
  }

  try {
    const response = await axiosInstance.get(
      `/subscription/checkout-link`,
      {
        params: params
      }
    );

    if (response.data.data.url) redirectUrl = response.data.data.url;
    else {
      throw new Error(response.data.message);
    }
  } catch (_) {
    throw new Error("Failed to generate checkout link" + JSON.stringify(_));
  }

  window.location.assign(redirectUrl);
}

export async function generateUserStripe(
  priceId: string,
  userId?: string,
  isPaid?: boolean,
  isCanceled?: boolean,
  base_url?: string,
  trial?: boolean,
): Promise<any> {
  let redirectUrl: string = "";

  try {
    if (!userId) {
      throw new Error("Unauthorized");
    }
    if (isPaid && !isCanceled) {
      // Go to customer portal.
      const response = await axiosInstance.get(
        `/subscription/stripe/cs-link?base_url=${base_url}`,
      );

      if (response.data.data.url) redirectUrl = response.data.data.url;
      else {
        throw new Error(response.data.message);
      }
    } else {
      // generate checkout link

      const response = await axiosInstance.get(
        `/subscription/checkout-link?base_url=${base_url}&price_id=${priceId}&requested_trial=${trial}`,
      );
      if (response.data.data.url) redirectUrl = response.data.data.url;
      else {
        throw new Error(response.data.message);
      }
    }
  } catch (_) {
    throw new Error(
      "Failed to generate user stripe session" + JSON.stringify(_),
    );
  }

  // no revalidatePath because redirect
  window.location.assign(redirectUrl);
}

